import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/machine/products2/categories-products/filter'; // Importing Filter component
import Table from 'views/machine/products2/categories-products/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Represents the CategoriesProductsView class.
 * @extends JetView
 */
export default class CategoriesProductsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // View type is a form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive layout identifier
                    type: 'wide', // Type of the column
                    cols: [left], // Columns layout containing the left section
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {}
}

// FILE DOCUMENTED
